import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TextKeyConstants } from 'src/app/models/Constants';
import { ModalConfiguration } from 'src/app/models/ModalConfiguration';
import { GeneralService } from 'src/app/services/general.service';
@Component({
  selector: 'verify-pending-modal',
  templateUrl: './verify-pending-modal.component.html',
  styleUrl: './verify-pending-modal.component.scss',
})
export class VerifyPendingModalComponent implements OnDestroy {
  subscriptions: Subscription = new Subscription();
  @Input() isModalOpen: boolean = false;
  @Output() clickSubmit: EventEmitter<boolean> = new EventEmitter();
  @Output() clickClose: EventEmitter<void> = new EventEmitter();
  PendingVerifyInfo = '';
  modalConfiguration: ModalConfiguration = {
    header: 'Verify Cell Phone Number',
    height: 300,
    width: 550,
    button2: {
      text: 'Skip Verify',
      buttonClass: 'button button-light me-2',
      callback: () => this.submitVerification(),
      disableCallback: () => false,
    },
    includeCancelButton: false,
    cancelButtonText: 'OK',
    button1: {
      text: 'OK',
      buttonClass: 'button button-dark me-2',
      callback: () => {
        this.closeModal();
      },
      disableCallback: () => false,
    },
    isCloseable: true,
    areButtonsRightAligned: true,
  };

  constructor(private readonly generalService: GeneralService) {
    this.subscriptions.add(
      this.generalService.textMessageArr.subscribe(() => {
        this.PendingVerifyInfo = this.generalService?.GetTextMessage(
          TextKeyConstants.VerificationPendingInfo,
        );
      }),
    );
  }

  submitVerification(): void {
    this.clickSubmit.emit(true);
  }

  closeModal(): void {
    this.isModalOpen = false;
    this.clickClose.emit();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
